import { useState } from 'react';
import { Link } from 'react-router-dom';
import confetti from 'canvas-confetti';
import './App.css';

function Home() {
  const backgroundImage = '/background.jpg';
  const [randomRotation] = useState(() => (Math.random() * 10) - 5); // Random value between -5 and 5, calculated only once
  const [scale, setScale] = useState(1);
  const [isHovered, setIsHovered] = useState(false);
  
  const handleClick = () => {
    setScale(0.9);
    setTimeout(() => {
      setScale(isHovered ? 1.1 : 1);
    }, 100);
    
    // Trigger 2 fireworks
    const randomInRange = (min, max) => Math.random() * (max - min) + min;
    const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };
    
    // First firework
    confetti({
      ...defaults,
      particleCount: 50,
      origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
    });
    
    // Second firework
    setTimeout(() => {
      confetti({
        ...defaults,
        particleCount: 50,
        origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
      });
    }, 200);
  };
  
  const handleMouseEnter = () => {
    setIsHovered(true);
    setScale(1.1);
  };
  
  const handleMouseLeave = () => {
    setIsHovered(false);
    setScale(1);
  };
  
  return (
    <div className="App" style={{ backgroundImage: `url(${backgroundImage})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center center' }}>
      <div className="content">
        <img 
          src="/logo.png" 
          alt="tnysocial" 
          className="logo" 
          style={{ transform: `rotate(${randomRotation}deg) scale(${scale})` }}
          onClick={handleClick}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        />
        <p className="tagline">building cool social apps</p>
      </div>
      <footer className="footer">
        <Link to="/terms" className="footer-link">terms & conditions</Link>
        <a href="mailto:hello@tnysocial.com" className="footer-link">support</a>
        <Link to="/privacy" className="footer-link">privacy policy</Link>
      </footer>
    </div>
  );
}

export default Home;

